import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { DeleteComponent } from '../../../../components/general/general-component/abstruct-component/DeleteComponent'
import { deleteOrder, loadOrders } from '../../../../store/Actions/ActionOrders'
import Warning from '../../../../components/general/general-component/warning-delete/Warning'
import Table2 from '../../../../components/table/Table2'
import SectionTopOfTable from '../../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import { ColumnRequests } from '../../../../components/general/general-component/columns-component/ColumnRequests'
import { ColumnOrders } from '../../../../components/general/general-component/columns-component/ColumnOrders'

const fake = [
    {
        id: 1,
        request_date: "2024-04-15",
        received_by: "John Doe1",
        location: "Warehouse A"
    },
    {
        id: 2,
        request_date: "2024-04-15",
        received_by: "John Doe2",
        location: "Warehouse B"
    },
    {
        id: 3,
        request_date: "2024-04-15",
        received_by: "John Doe3",
        location: "Warehouse C"
    },
]
const Orders = ({setOrderId,setActiveSection}) => {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { orders, loadingOrders } = useSelectorCustom()
    //const { state, setOpen, handleEdit, setopenEdit, setStateCustom } = VariableRequests()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [ordersArr, setOrdersArr] = useState(fake)
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...ordersArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setOrdersArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, ordersArr]);
    /*useEffect(() => {
        if (orders?.length >= 0) {
            setOrdersArr(orders)
        }
    }, [orders]);*/

    useEffect(() => {
        //dispatch(loadOrders())
    }, []);
    const handleDelete = (id) => {
        dispatch(deleteOrder(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const createDelivery =(e,id)=>{
        e.preventDefault()
        setActiveSection('Delivery')
        setOrderId(id)
    }
    const { columns } = ColumnOrders(translate, warning,createDelivery, langLocal)
    return (
        <>
            <main>
                {/*<FilterRequest translate={translate} />*/}
                <div className="div_table" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    <SectionTopOfTable langLocal={langLocal} title={translate('orders')}   />
                    {/*
                        loadingWarehouses == false ? (
                            <Table2 col={columns} roo={warehousesArr} />
                        ) : <InnerLoader />
                        */}
                    <Table2 col={columns} roo={ordersArr} />
                </div>
                {
                    stateD.deletee == true ? (
                        <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                    ) : <></>
                }
            </main>
        </>
    )
}

export default Orders
